import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { ModalController } from '@ionic/angular';
import { IonButton } from '@ionic/angular/standalone';
import { TranslatePipe } from '@ngx-translate/core';

interface ModalInfoItem {
	title?: string;
	info?: string;
	mainButton?: string;
	icon?: string;
	closeButton?: string;
	subTitle?: string;
	phoneNumber?: string;
}

@Component({
	selector: 'app-info-modal',
	templateUrl: './info-modal.component.html',
	styleUrls: ['./info-modal.component.scss'],
	standalone: true,
	imports: [IonButton, TranslatePipe],
	changeDetection: ChangeDetectionStrategy.OnPush,
})
export class InfoModalComponent {
	title = '';
	info = '';
	icon = '';
	mainButton = '';
	closeButton = '';
	phoneNumber = '';
	subTitle = '';

	public modalCtrl = inject(ModalController);
	constructor() {}

	static async show(
		modalCtrl: ModalController,
		{ title, info, icon, mainButton, closeButton, phoneNumber, subTitle }: ModalInfoItem
	) {
		const modal = await modalCtrl.create({
			cssClass: 'auto-height bottom',
			component: InfoModalComponent,
			componentProps: {
				title,
				info,
				icon,
				mainButton,
				closeButton,
				phoneNumber,
				subTitle,
			},
			showBackdrop: true,
			backdropDismiss: true,
		});
		await modal.present();
		return (await modal.onDidDismiss()).data;
	}

	dismiss(value: boolean) {
		this.modalCtrl.dismiss(value);
	}
}
